import React, { useState } from 'react';
import { Step, StepButton, StepContent, Stepper, Typography, makeStyles } from '@material-ui/core';

import CustomerForms from '../forms/CustomerForms';
import AddressForms from '../forms/AddressForms';
import PaymentForms from '../forms/PaymentForms';
import SummaryStep from '../SummaryStep';

const useStyles = makeStyles(() => ({
  stepper: {
    padding: 0
  }
}));

export default function FormsStepper({ onSubmit, boleto }) {
  const classes = useStyles();

  const [step, setStep] = useState(0);
  const [customer, setCustomer] = useState(null);
  const [address, setAddress] = useState(null);
  const [payment, setPayment] = useState(null);

  const nextStep = () => {
    setStep(prev => prev + 1);
  }

  const manualStep = (step) => {
    setStep(step);
  }

  const handleLastStep = () => {

  }

  const handleCustomerSubmit = (customer) => {
    setCustomer(customer);
    setAddress(customer?.address);
    nextStep();
  }

  const handleAddressSubmit = (address) => {
    setAddress(address);
    nextStep();
  }

  const handlePaymentSubmit = (payment) => {
    setPayment(payment);
    handleSummaryStepClick({ hasFinished: true });
  }

  const hasAllStepsFinished = !!customer && !!address && !!payment;

  const handleSummaryStepClick = ({ hasFinished = false}) => {
    if(!hasFinished && !hasAllStepsFinished) {
      alert('Existe etapas pendentes');
      return;
    }

    manualStep(3);
  }
  
  return (
    <Stepper nonLinear activeStep={step} orientation="vertical" className={classes.stepper}>
      <Step completed={!!customer}>
        <StepButton onClick={() => manualStep(0)}>
          <Typography variant="subtitle1">
            Dados do Comprador
          </Typography>
        </StepButton>
        <StepContent>
          <CustomerForms defaultCustomer={customer} onSubmitCustomer={handleCustomerSubmit}/>
        </StepContent>
      </Step>
      <Step completed={!!address}>
        <StepButton onClick={() => manualStep(1)}>
          <Typography variant="subtitle1">
            Endereço do Comprador
          </Typography>
        </StepButton>
        <StepContent>
          <AddressForms defaultAddress={address} onAddressSubmit={handleAddressSubmit} />
        </StepContent>
      </Step>
      <Step completed={!!payment}>
        <StepButton onClick={() => manualStep(2)}>
          <Typography variant="subtitle1">
            Dados do Pagamento
          </Typography>
        </StepButton>
        <StepContent>
          <PaymentForms defaultPayment={payment} onSubmitPayment={handlePaymentSubmit} />
        </StepContent>
      </Step>
      <Step>
        <StepButton onClick={handleSummaryStepClick}>
          <Typography variant="subtitle1">
            Resumo
          </Typography>
        </StepButton>
        <StepContent>
          <SummaryStep customer={customer} address={address} payment={payment} onSubmit={onSubmit} boleto={boleto} />
        </StepContent>
      </Step>
    </Stepper>
  )
}